export default "__VITE_ASSET__docgwpj6__"